import { render, staticRenderFns } from "./HSCodeCreateAdmin.vue?vue&type=template&id=03a29647&scoped=true"
import script from "./HSCodeCreateAdmin.vue?vue&type=script&lang=js"
export * from "./HSCodeCreateAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a29647",
  null
  
)

export default component.exports